let base_url = "https://avant-api.epmsbirkuchi.com/"
// let base_url = "http://localhost:8000/"
// let base_url = "https://avant-api.webrefiner.com/"
// let base_url = "https://5wieiji7yr.sharedwithexpose.com/"

export default base_url